// Detailed, multi-line summary of a patient's long-term medications. Shared by
// referrals and pregnancy so the imported text is identical everywhere.
export const formatLongTermMedicationsToString = (medications) => {
  if (!medications || !Array.isArray(medications) || medications.length === 0) {
    return "";
  }

  return medications
    .map((medication) => {
      const lines = [];

      if (medication.tradeName) {
        lines.push(`Trade Name: ${medication.tradeName}`);
      }

      if (medication.genericName && medication.genericName.trim() !== "") {
        lines.push(`Generic Name: ${medication.genericName}`);
      }

      if (medication.manufacturer) {
        lines.push(`Manufacturer: ${medication.manufacturer}`);
      }

      if (medication.dosage) {
        lines.push(`Dosage: ${medication.dosage}`);
      }

      if (medication.strength) {
        lines.push(`Strength: ${medication.strength}`);
      }

      if (medication.form) {
        lines.push(`Form: ${medication.form}`);
      }

      if (medication.route) {
        lines.push(`Route: ${medication.route}`);
      }

      if (medication.frequency) {
        lines.push(`Frequency: ${medication.frequency}`);
      }

      if (medication.quantity) {
        lines.push(`Quantity: ${medication.quantity}`);
      }

      if (
        medication.repeat !== null &&
        medication.repeat !== undefined &&
        medication.repeat > 0
      ) {
        lines.push(`Repeat: ${medication.repeat}`);
      }

      if (medication.startDate) {
        lines.push(`Start Date: ${medication.startDate}`);
      }

      if (medication.duration && medication.durationFormat) {
        lines.push(
          `Duration: ${medication.duration} ${medication.durationFormat}`
        );
      }

      if (medication.instructions) {
        lines.push(`Instructions: ${medication.instructions}`);
      }

      if (
        medication.stopMedication !== null &&
        medication.stopMedication !== undefined
      ) {
        lines.push(
          `Stop Medication: ${medication.stopMedication ? "Yes" : "No"}`
        );
      }

      return lines.join("\n");
    })
    .join("\n\n");
};

// HTML variant for rich-text (Quill) editors, where raw newlines collapse.
export const formatLongTermMedicationsToHtml = (medications) =>
  formatLongTermMedicationsToString(medications).replace(/\n/g, "<br>");
